module.exports = __webpack_public_path__ + "img/linggekj_logo@3x.94a04869.png";